import { useEffect, useState } from 'react'
import { gql } from '@apollo/client'
import { apolloClient } from 'lib/apollo'
import { MasterData, Query } from 'types/graphql'

const QUERY_DELIVERY_COMPANY = gql`
  query {
    getMasterData(name: DELIVERY_COMPANY) {
      code
      displayName
    }
  }
`

const useQueryDeliveryCompanies = (): MasterData[] => {
  const [deliveryCompanies, setDeliveryCompanies] = useState<MasterData[]>([])
  useEffect(() => {
    ;(async () => {
      const { error, data } = await apolloClient.query<Query>({ query: QUERY_DELIVERY_COMPANY })
      if (error) {
        console.error(error)
        return
      }
      if (data?.getMasterData) {
        setDeliveryCompanies([...data.getMasterData])
      }
    })()
  }, [])
  return deliveryCompanies
}

export default useQueryDeliveryCompanies
